import { render, staticRenderFns } from "./ColorInput.vue?vue&type=template&id=c8768ec2&scoped=true&"
import script from "./ColorInput.vue?vue&type=script&lang=js&"
export * from "./ColorInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8768ec2",
  null
  
)

export default component.exports